export default __webpack_public_path__ + "static/media/Icono-trafilex-150-1.fe5aa1cb.png";